// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchItem_root__23Nkv","name":"MatchItem_name__EX597","avatar":"MatchItem_avatar__yq_8w"};